// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TabMenu_wrapper__SfJyP","tabs":"TabMenu_tabs__2wKKO","tab":"TabMenu_tab__1ybpL","active":"TabMenu_active__mXy2u","disabled":"TabMenu_disabled__1tjWQ"};